import { Anvil, Fuel, HardHat, Wheat, Newspaper, Network } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { industries } from "@/data/content";
import { useSiteContent } from "@/i18n/SiteContentContext";

const iconList = [Anvil, Fuel, HardHat, Wheat, Newspaper, Network];

export const Industries = () => {
  const { get } = useSiteContent();
  const industryList = get("industries", industries);
  return (
  <section id="industries" data-testid="industries-section" className="honeycomb-bg-strong relative overflow-hidden bg-gradient-to-b from-mist via-ice/40 to-mist py-28 md:py-40">
    <div className="pointer-events-none absolute -right-32 top-20 h-80 w-80 rounded-full bg-sky/15 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        number="05"
        eyebrow="Industries Served"
        title={<>The cargo changes. <span className="text-royal/40">The standard doesn't.</span></>}
        description="Six industries trust Mandair with their most demanding loads — from molten-grade steel to fresh food."
      />

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {industryList.map((ind, i) => {
          const Icon = iconList[i % iconList.length];
          return (
            <Reveal key={ind.name} delay={i * 0.08}>
              <div
                data-testid={`industry-card-${i}`}
                className="group relative h-64 cursor-pointer overflow-hidden rounded-3xl border border-navy/10 shadow-xl shadow-royal/15 transition-all duration-500 hover:-translate-y-2 hover:border-gold/50 hover:shadow-2xl hover:shadow-gold/25"
              >
                <img src={ind.image} alt={ind.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/45 to-navy/5 transition-all duration-500 group-hover:via-royal/60" />
                <div className="relative flex h-full flex-col justify-end p-7">
                  <span className="mb-4 grid h-12 w-12 place-items-center hex-clip bg-gold shadow-lg transition-transform duration-500 group-hover:scale-110">
                    <Icon className="h-5 w-5 text-navy" />
                  </span>
                  <span className="font-jakarta text-lg font-extrabold uppercase tracking-widest text-white md:text-xl">
                    {ind.name}
                  </span>
                  <span className="mt-2 block h-1 w-10 rounded-full bg-gold transition-all duration-500 group-hover:w-24" />
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};